module.exports = __webpack_public_path__ + "img/capacitor-meh.069a7066.jpg";